import "parsleyjs"
import "jquery-mask-plugin"
import "@fortawesome/fontawesome-free/js/all"
import "packs/user/stripe"
import "packs/user/order"